import React from 'react';
import WorkList from '../Audits/WorkList';

const Bookings = () => (
  <WorkList
    kind="booking"
    title="Bookings"
    subtitle="Confirmed jobs from accepted quotes. Accept them, then assign a technician."
    idKey="booking_id"
    detailPath="/bookings/manage-booking"
    dateLabel="Job date"
  />
);

export default Bookings;
